import React from "react";
import Typography from "../../../../../../components/Typography/Typography";
import Button from "../../../../../../components/Button/Button";
import { FieldArray } from "formik";
import { TextField } from "../../../../../../components/forms";
import TextArea from "../../../../../../components/forms/TextArea";
import UnifiedFileUpload from "../../../../../../components/forms/UnifiedFileUpload";

const ProjectSection = ({
    initialValues,
    bottomImage,
    handleBottomImageSelected,
}) => {
    return (
        <div className="mb-4">
            <Typography variant="h5" className="mb-3">
                Sustainability Projects
            </Typography>

            <div className="mb-3">
                <UnifiedFileUpload
                    name="profitSectionBottomImage"
                    label="Section Image"
                    fileType="image"
                    initialFile={
                        initialValues?.profit_section_image_bottom_file_url
                            ? {
                                  url: initialValues?.profit_section_image_bottom_file_url,
                                  name: initialValues?.profit_section_image_bottom_file_name,
                                  isExisting: true,
                              }
                            : null
                    }
                    selectedFile={bottomImage}
                    onFileSelected={handleBottomImageSelected}
                />
            </div>

            <FieldArray name="sustainability_projects">
                {({ push, remove, form }) => (
                    <div>
                        {(form?.values?.sustainability_projects || []).map(
                            (project, index) => (
                                <div className="card mb-4" key={index}>
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <Typography variant="h6">
                                                Project {index + 1}
                                            </Typography>
                                            <Button
                                                type="button"
                                                variant="danger"
                                                size="sm"
                                                fullWidth={false}
                                                onClick={() => remove(index)}
                                            >
                                                <i className="bi bi-x-lg" />
                                            </Button>
                                        </div>
                                        <div className="mb-3">
                                            <TextField
                                                name={`sustainability_projects.${index}.project_title`}
                                                label="Project Title"
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <TextArea
                                                name={`sustainability_projects.${index}.project_description`}
                                                label="Project Description"
                                                rows={3}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ),
                        )}
                        {form.values?.sustainability_projects?.length < 10 && (
                            <Button
                                variant="secondary"
                                type="button"
                                onClick={() =>
                                    push({
                                        project_title: "",
                                        // project_image: null,
                                        project_description: "",
                                    })
                                }
                                startIcon={<i className="bi bi-plus" />}
                                size="sm"
                            >
                                Add Project
                            </Button>
                        )}
                    </div>
                )}
            </FieldArray>
        </div>
    );
};

export default ProjectSection;
